(function () {
  var requestedView = null;
  window.openLoginPopup = function (view) {
    requestedView = view || null;
    try { if (typeof openLogin === 'function') { openLogin(view); } } catch (e) { };
  };

  var popup = document.querySelector('.login-popup');
  if (!popup) return;

  var panel = popup.querySelector('#login-popup-panel');
  var backdrop = popup.querySelector('[data-login-backdrop]');
  var closeBtn = popup.querySelector('.login-popup-close');
  var form = popup.querySelector('form');
  var loginForm = popup.querySelector('#LoginFormPopup');
  var recoverForm = popup.querySelector('#RecoverFormPopup');
  var recoverContainer = popup.querySelector('#LoginPopupRecover');
  var registerForm = popup.querySelector('#RegisterFormPopup');
  var resetForm = popup.querySelector('#ResetFormPopup');
  var resetContainer = popup.querySelector('#LoginPopupReset');
  var titleElement = popup.querySelector('#login-popup-title');
  var forceResetView = popup.hasAttribute('data-login-force-reset');

  function updatePopupTitle(titleKey) {
    if (titleElement && window.loginPopupTranslations && window.loginPopupTranslations[titleKey]) {
      titleElement.textContent = window.loginPopupTranslations[titleKey];
    }
  }

  function openLogin(initialView) {
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('login-popup--open');
    document.body.classList.add('login-popup-open');
    if (panel) panel.style.display = 'block';
    var viewToShow = initialView || requestedView;
    if (!viewToShow && forceResetView) {
      viewToShow = 'reset';
    }
    try {
      if (viewToShow === 'register') {
        showRegister();
      } else if (viewToShow === 'recover') {
        showRecover();
      } else if (viewToShow === 'reset') {
        showReset();
      } else {
        showLogin();
      }
    } catch (e) { }
    requestedView = null;
  }

  function isOnAccountPage() {
    const currentPath = window.location.pathname.toLowerCase();
    // Login, register, and recover now use dedicated pages — only auto-open for reset
    const isResetPage = currentPath.indexOf('/account/reset') !== -1;

    return isResetPage;
  }

  function isAuthPopupLockedPage() {
    // No pages use the locked popup anymore — login/register/recover are dedicated pages
    return false;
  }

  function applyAuthPopupLockState() {
    var isLocked = isAuthPopupLockedPage();
    popup.classList.toggle('login-popup--locked', isLocked);

    if (closeBtn) {
      closeBtn.setAttribute('aria-hidden', isLocked ? 'true' : 'false');
      closeBtn.tabIndex = isLocked ? -1 : 0;
    }
  }

  function closeLogin() {
    if (isAuthPopupLockedPage()) return;
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('login-popup--open');
    document.body.classList.remove('login-popup-open');
    if (panel) panel.style.display = '';
  }

  function shouldInterceptAnchor(anchor) {
    if (!anchor) return false;
    // Ignore modified clicks or targets that open a new window
    // (These are filtered at event-level but double-check here)
    var target = (anchor.getAttribute('target') || '').toLowerCase();
    if (target === '_blank') return false;

    var hrefAttr = anchor.getAttribute('href') || '';
    var href = hrefAttr.toLowerCase();
    var abs = '';
    try { abs = (anchor.href || '').toLowerCase(); } catch (e) { }

    if (!href && !abs) return false;

    // Explicit trigger attribute
    if (anchor.hasAttribute('data-open-login-popup')) return true;

    // Ignore external links
    var isExternal = abs.indexOf('http') === 0 && abs.indexOf(location.origin.toLowerCase()) !== 0;
    if (isExternal) return false;

    // Login, register, and recover now use dedicated pages — do NOT intercept
    // Only intercept hash-only links on the reset password page
    if (href.indexOf('#reset') !== -1 || abs.indexOf('#reset') !== -1) return true;

    return false;
  }

  function getViewFromHash(hashValue) {
    var hash = (hashValue || '').toLowerCase();
    if (hash === '#recover') return 'recover';
    if (hash === '#register') return 'register';
    if (hash === '#reset') return 'reset';
    return null;
  }

  function getClosestFromEventTarget(target, selector) {
    if (!target) return null;
    var elementTarget = target.nodeType === Node.TEXT_NODE ? target.parentElement : target;
    if (!elementTarget || !elementTarget.closest) return null;
    return elementTarget.closest(selector);
  }

  function setElementVisibility(element, shouldShow) {
    if (!element) return;
    element.hidden = !shouldShow;
    element.style.display = shouldShow ? '' : 'none';
    element.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  }

  // Toggle and close handlers
  if (closeBtn) closeBtn.addEventListener('click', closeLogin);
  if (backdrop) backdrop.addEventListener('click', closeLogin);

  // Click outside to close - more robust detection
  document.addEventListener('click', function (e) {
    var isOpen = popup.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;

    // Check if the click target is a login trigger link - if so, don't close
    var anchor = getClosestFromEventTarget(e.target, 'a');
    if (anchor && shouldInterceptAnchor(anchor)) {
      return;
    }

    // Check if click is outside the popup panel
    if (panel && !panel.contains(e.target)) {
      closeLogin();
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLogin(); });

  // Intercept click in capture phase to prevent navigation
  document.addEventListener('click', function (evt) {
    try {
      var anchor = getClosestFromEventTarget(evt.target, 'a');
      if (!anchor) return;
      if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      if (!shouldInterceptAnchor(anchor)) return;

      // Get the ORIGINAL href BEFORE modifying anything
      var origHref = anchor.getAttribute('href') || '';
      var origHrefAbs = '';
      try { origHrefAbs = (anchor.href || '').toLowerCase(); } catch (e) { }
      var origHrefAttr = origHref.toLowerCase();

      // Prevent navigation
      evt.preventDefault();
      evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();

      // Determine which form to show based on ORIGINAL href
      var showRegisterForm = origHrefAttr.indexOf('/account/register') !== -1 || origHrefAbs.indexOf('/account/register') !== -1;
      var showRecoverForm = origHrefAttr.indexOf('/account/recover') !== -1 || origHrefAbs.indexOf('/account/recover') !== -1;
      var showRecoverHash = origHrefAttr.indexOf('#recover') !== -1 || origHrefAbs.indexOf('#recover') !== -1;
      var showRegisterHash = origHrefAttr.indexOf('#register') !== -1 || origHrefAbs.indexOf('#register') !== -1;
      var showResetHash = origHrefAttr.indexOf('#reset') !== -1 || origHrefAbs.indexOf('#reset') !== -1;

      var requested = null;
      if (showRecoverHash || showRecoverForm) {
        requested = 'recover';
      } else if (showResetHash) {
        requested = 'reset';
      } else if (showRegisterHash || showRegisterForm) {
        requested = 'register';
      }

      // Open popup with optional view
      openLogin(requested);

    } catch (e) { /* noop */ }
  }, true);

  // Keep default form submission (no AJAX) so Shopify handles auth & redirects
  if (form) {
    form.addEventListener('submit', function () {
      // optionally add a loading state
      try { popup.classList.add('is-submitting'); } catch (e) { }
    });
  }

  // View toggling between login and recover
  function showRecover() {
    try {
      setElementVisibility(loginForm, false);
      setElementVisibility(registerForm, false);
      setElementVisibility(recoverForm, true);
      setElementVisibility(recoverContainer, true);
      setElementVisibility(resetForm, false);
      setElementVisibility(resetContainer, false);
      updatePopupTitle('recover');
    } catch (e) { }
  }

  function showLogin() {
    try {
      setElementVisibility(loginForm, true);
      setElementVisibility(registerForm, false);
      setElementVisibility(recoverForm, false);
      setElementVisibility(recoverContainer, false);
      setElementVisibility(resetForm, false);
      setElementVisibility(resetContainer, false);
      updatePopupTitle('login');
    } catch (e) { }
  }

  function showRegister() {
    try {
      setElementVisibility(loginForm, false);
      setElementVisibility(registerForm, true);
      setElementVisibility(recoverForm, false);
      setElementVisibility(recoverContainer, false);
      setElementVisibility(resetForm, false);
      setElementVisibility(resetContainer, false);
      updatePopupTitle('register');
    } catch (e) { }
  }

  function showReset() {
    try {
      setElementVisibility(loginForm, false);
      setElementVisibility(registerForm, false);
      setElementVisibility(recoverForm, false);
      setElementVisibility(recoverContainer, false);
      setElementVisibility(resetForm, true);
      setElementVisibility(resetContainer, true);
      updatePopupTitle('reset');
    } catch (e) { }
  }

  popup.addEventListener('click', function (e) {
    var actionEl = getClosestFromEventTarget(e.target, '[data-login-popup-action]');
    if (!actionEl) return;
    e.preventDefault();
    var action = actionEl.getAttribute('data-login-popup-action');
    if (action === 'show-recover') showRecover();
    if (action === 'show-login') showLogin();
    if (action === 'show-register') showRegister();
    if (action === 'show-reset') showReset();
  });

  // Helper functions to prevent auto-focus on inputs
  var originalTabIndex = new Map();
  var preventAutoFocus = false;

  function disableAutoFocus() {
    try {
      preventAutoFocus = true;
      // Find all input elements in the popup and temporarily make them unfocusable
      const inputs = popup.querySelectorAll('input[type="email"], input[type="password"], input[type="text"]');
      inputs.forEach(input => {
        originalTabIndex.set(input, input.tabIndex);
        input.tabIndex = -1;
        // Also blur if already focused
        if (document.activeElement === input) {
          input.blur();
        }
      });
    } catch (e) { }
  }

  function enableAutoFocus() {
    try {
      // Restore original tabIndex values
      originalTabIndex.forEach((tabIndex, input) => {
        input.tabIndex = tabIndex;
      });
      originalTabIndex.clear();
      preventAutoFocus = false;
    } catch (e) { }
  }

  // Add event listener to prevent focus during auto-open
  popup.addEventListener('focusin', function (e) {
    if (preventAutoFocus && e.target.matches && e.target.matches('input')) {
      e.target.blur();
      e.preventDefault();
    }
  });

  // Auto-open login popup only on reset password page
  function autoOpenOnAccountPage() {
    if (!isOnAccountPage()) return;

    const currentPath = window.location.pathname.toLowerCase();
    const isResetPage = currentPath.indexOf('/account/reset') !== -1;

    if (!isResetPage && !forceResetView) return;

    // Wait for DOM to be ready
    setTimeout(() => {
      // Temporarily disable auto-focus behavior
      disableAutoFocus();

      openLogin('reset');

      // Re-enable auto-focus after a short delay
      setTimeout(() => {
        enableAutoFocus();
      }, 500);
    }, 100);
  }

  // Check if the register form has errors and show it if needed
  function checkForRegisterErrors() {
    if (registerForm && !registerForm.hidden) {
      // Register form is already visible, check if it has errors
      const hasErrors = registerForm.querySelector('.form__message');
      if (hasErrors) {
        // Make sure register view is shown
        showRegister();
      }
    }
  }

  // If URL hash is #recover, open and show recover view
  // Run auto-open check when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpenOnAccountPage);
  } else {
    autoOpenOnAccountPage();
  }

  applyAuthPopupLockState();

  // Keep hash-only auth links in sync with popup view changes
  window.addEventListener('hashchange', function () {
    var viewFromHash = getViewFromHash(window.location.hash || '');
    if (!viewFromHash) return;
    openLogin(viewFromHash);
  });
})();
